import {ServiceClass} from '@/decorators';
import {BaseApi} from './base.api';

@ServiceClass()
export class SensorAlertApi extends BaseApi {
    public getAlertsByLocationId(locationId: string) {
        return this.GET_RequestAsync<any[]>(`${this.ApiUrl}/sensor-alerts/locations/${locationId}`);
    }
    public getLatestAlertByLocationId(locationId: string) {
        return this.GET_RequestAsync<any[]>(`${this.ApiUrl}/sensor-alerts/locations/${locationId}/latest`);
    }
    public getAlertsBySiteId(siteId: string) {
        return this.GET_RequestAsync<any[]>(`${this.ApiUrl}/sensor-alerts/sites/${siteId}`);
    }
}
